import useEntity from "../../hooks/useCutting";
import CuttingDetail from "../../components/cutting/CuttingDetail/CuttingDetail";
import CuttingScoped from "../../components/cutting/CuttingDetail/CuttingScoped";
import CuttingTabs from "../../components/cutting/CuttingDetail/CuttingTabs";
import { useGetCuttingQuery } from "../../apis/Cutting.api";
import { PrimaryCutting } from "../../types/models/Cutting";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import {cuttingStateCheck, shippingStateClosedCheck} from "../../stateChecks.ts";

const CuttingDetailPage = () => {

    useTitle(t`Details Cutting`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { cuttingId: id } = useParams();

    const { data, refetch } = useGetCuttingQuery(PrimaryCutting.fromPath(id))
    const { deleteCutting } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteCutting(data, '..')
    }, [data, deleteCutting])

    const stateAllowed = cuttingStateCheck(session, data?.state)

    if (id === 'scoped') {
        return (<CuttingScoped/>)
    }

    return (
        <Box data-testid="Cutting-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <CuttingDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Cuttings/update/view'
        ) ||
session.hasPermission(
            data.contractorScopeGroupId,
            'applications/timber/entities/Cuttings/update/view'
        ) ||
false) &&
                        shippingStateClosedCheck(data?.state) &&
                        stateAllowed
                        &&
                        <Button size="small" variant="outlined" data-testid="Cutting-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Cuttings/delete/view'
        ) ||
session.hasPermission(
            data.contractorScopeGroupId,
            'applications/timber/entities/Cuttings/delete/view'
        ) ||
false) &&
                        shippingStateClosedCheck(data?.state)
                        && stateAllowed
                        &&
                        <Button size="small" color="error" variant="outlined" data-testid="Cutting-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <CuttingTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default CuttingDetailPage;
